import {Component, Input, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent implements OnInit {
  @Input() iconBtnUrl: string;
  @Input() imgUrl?: string;
  @Input() imgLogout?: string;
  @Input() title: string;
  @Input() text: string;
  @Input() btnText: string;
  @Input() btnStyle: string;
  @Input() hasBtn: boolean;
  @Output() btnClicked = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  btnClick() {
    this.btnClicked.emit({});
  }
}
